/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'RECRUITMENT_FEES_AND_EXPENSES',
              'EMPLOYMENT_CONTRACTS',
              'DEPOSITS',
              'WAGES_AND_BENEFITS',
              'WORKING_HOURS',
              'ACCOMMODATIONS',
              'FREEDOM_OF_MOVEMENT',
              'NON_DISCRIMINATION_IN_EMPLOYMENT',
              'HARASSMENT_AND_ABUSE_IN_EMPLOYMENT',
              'DISCIPLINE_IN_EMPLOYMENT',
              'END_OF_EMPLOYMENT',
              'REQUIREMENTS_FOR_LABOR_AGENTS_BROKERS',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    which_of_the_following_topics_are_included_win_the_facs_written_12: valueSchema,
  },
}
